import React from 'react';

const AIAssistantChatHistoryEmpty = () => {
  return <div className="ai-assistant-chat-history-empty">Chat history is empty</div>;
};

export default AIAssistantChatHistoryEmpty;
